export const missaoCards = [
  {
    titulo: 'Tratamento personalizado',
    descricao: 'Cuidar de cada paciente com empatia, atenção e respeito às suas necessidades individuais.'
  },
  {
    titulo: 'Excelência',
    descricao: 'Buscar constantemente as melhores práticas médicas e terapêuticas para garantir tratamentos eficazes e atualizados.'
  },
  {
    titulo: 'Prevenção',
    descricao: 'Cuidar da saúde por meio de práticas preventivas e acompanhamento contínuo.'
  },
  {
    titulo: 'Integração',
    descricao: 'Unir diferentes especialidades para um cuidado integrativo.'
  },
  {
    titulo: 'Educação e Conhecimento',
    descricao: 'Informar e capacitar pacientes para que sejam protagonistas de sua própria saúde.'
  },
  {
    titulo: 'Confiança e Ética',
    descricao: 'Atuar com transparência, ética e profissionalismo em todos os relacionamentos.'
  },
  {
    titulo: 'Compromisso com a Vida',
    descricao: 'Valorizar cada etapa da vida, promovendo bem-estar e longevidade com qualidade.'
  }
];

export const CARDS_PER_PAGE = 3;
